// @generated stub file for google/api/field_behavior.proto
// This is a stub to satisfy imports from generated protobuf files
/* eslint-disable */

/**
 * Stub export for google.api.field_behavior
 * The google.api.field_behavior annotations are compile-time metadata only
 * and do not affect runtime behavior. They are stripped during code generation.
 * This stub provides a minimal GenFile object to satisfy imports.
 */
export const file_google_api_field_behavior = {
  kind: "file",
  edition: 999, // EDITION_PROTO3
  name: "google/api/field_behavior",
  proto: {
    name: "google/api/field_behavior.proto",
    syntax: "proto3"
  },
  deprecated: false,
  dependencies: [],
  enums: [],
  messages: [],
  services: [],
  extensions: []
};
